import { buildMakeUseAxios } from "@root/api/api.tools";
import { useCallback } from "react";

export const axios = buildMakeUseAxios(`${import.meta.env.VITE_CANDIDATE_SERVICE_URL}`);

export const useGetCandidateExist = () => {
  const [state, execute, cancel] = axios<boolean, void, unknown>(
    {
      url: "/candidates/exist",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidate: {
      city: string;
      postalCode: string;
      formatted: string;
      firstName: string;
      lastName: string;
    }) => {
      return execute({ params: candidate });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
